import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>Let's connect and build something amazing together!</p>
      <div className="contact-links">
        <a href="mailto:elvificent@gmail.com">Email</a>
        <a href="https://www.linkedin.com/in/chu-elvis-210597265/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        <a href="https://github.com/elvificent" target="_blank" rel="noopener noreferrer">GitHub</a>
      </div>
    </footer>
  );
};

export default Footer; 